import styled from 'styled-components';
import { string, func } from 'prop-types';
import { faSearch } from '@fortawesome/fontawesome-free-solid';

import StyledIcon from '../../components/shared/StyledIcon';
import { GREY_COLOR, MEDIUM_TEXT, TABLET_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';
import { HeaderMenuContext } from '../../pages';

const Container = styled.div`
  margin-left: 70px;
  position: relative;
  width: 40%;
  @media (max-width: ${TABLET_SIZE}) {
    margin-left: 0px;
    width: calc(100% - 90px);
  }
`;

const StyledInput = styled.input`
  background-color: transparent;
  border-radius: 10px;
  border: 1px solid ${({ fontColor }) => fontColor};
  color: ${({ fontColor }) => fontColor};
  font-size: ${MEDIUM_TEXT};
  height: 59px;
  outline-color: ${({ fontColor }) => fontColor};
  padding: 0px 30px;
  width: 100%;
  transition: all 150ms linear;

  &::placeholder {
    color: ${({ fontColor }) => fontColor};
  }

  &:focus {
    outline: none;
  }

  @media (max-width: ${TABLET_SIZE}) {
    width: 100%;
  }
`;

const IconWrapper = styled.i`
  color: ${GREY_COLOR};
  font-size: ${MEDIUM_TEXT};
  right: 22px;
  line-height: 60px;
  position: absolute;
`;

const SearchField = ({ fontColor, updateQuery, updateSearch, t }) => {
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      updateQuery();
    }
  };

  return (
    <Container>
      <IconWrapper>
        <StyledIcon
          icon={faSearch}
          size="1x"
          color={fontColor}
          onClick={() => updateQuery()}
        />
      </IconWrapper>
      <HeaderMenuContext.Consumer>
        {context => (
          <form>
            <StyledInput
              placeholder={t('COMPONENTS_HEADER_SEARCH_PLACEHOLDER')}
              fontColor={fontColor}
              value={context && context.searchString}
              onChange={event => updateSearch(event.target.value)}
              onKeyPress={handleKeyPress}
              aria-label={t('COMPONENTS_HEADER_SEARCH_PLACEHOLDER')}
            />
          </form>
        )}
      </HeaderMenuContext.Consumer>
    </Container>
  );
};

SearchField.propTypes = {
  updateQuery: func.isRequired,
  updateSearch: func.isRequired,
  fontColor: string.isRequired,
};

export default withI18next()(SearchField);



// WEBPACK FOOTER //
// components/Header/SearchField.js